import { connect } from "react-redux";
import RenewApprovals from "./renewApprovals";
import { bindActionCreators } from "redux";
import { getApprovalList, acceptApproval, rejectApproval } from "services/redux/approvals/salesApprovals/action"
import {
  fetchZones,
  getListFilterData,
  getContractDetails,
} from "services/redux/sales/preSaleListing/action";
import {
  getRenewalApprovalList,
  acceptRenewalApproval, rejectRenewalApproval,
} from "services/redux/brandActivtion/sitesListing/action";

const mapStateToProps = (state) => ({
  approvalList: state.baSiteListingReducer.renewalList,
  getFetchZones: state.preSalesListReducer.getFetchZones,
  filterDropdownList: state.preSalesListReducer.filterDropdownList,
  viewDetails: state.preSalesListReducer.viewContract,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getApprovalList,
    acceptApproval,
    rejectApproval,
    fetchZones,
    getListFilterData,
    getRenewalApprovalList,
    acceptRenewalApproval,
    rejectRenewalApproval,
    getContractDetails,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RenewApprovals);
